import { Formik } from 'formik';
import noop from 'lodash/noop';
import T from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useWizard } from 'react-use-wizard';
import { reach } from 'yup';
import text from '../../text';
import { projectValidationSchema } from '../../validation';
import Control from '../form/Control';
var ProjectNameForm = function(props) {
    var onContinue = props.onContinue, onCancel = props.onCancel, project = props.project, onContinueText = props.onContinueText;
    var nextStep = useWizard().nextStep;
    var handleContinue = function(values) {
        onContinue(values);
        nextStep();
    };
    var handleCancel = function(event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        onCancel();
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "ProjectNameForm"
    }, /*#__PURE__*/ React.createElement(Formik, {
        initialValues: project,
        enableReinitialize: true,
        validateOnMount: true,
        validationSchema: reach(projectValidationSchema, 'project')
    }, function(param) {
        var handleChange = param.handleChange, handleBlur = param.handleBlur, isValid = param.isValid, values = param.values, errors = param.errors, touched = param.touched;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Control, {
            as: "input",
            type: "text",
            name: "name",
            isFailed: touched.name && !!errors.name,
            value: values === null || values === void 0 ? void 0 : values.name,
            onChange: function(e) {
                return handleChange(e);
            },
            onBlur: handleBlur,
            placeholder: text('enterProjectName'),
            validationError: touched.name && errors.name,
            autoComplete: "off"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "form-footer"
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: function() {
                return handleContinue(values);
            },
            disabled: !isValid
        }, onContinueText), /*#__PURE__*/ React.createElement("a", {
            name: "cancel",
            href: "#",
            onClick: handleCancel
        }, text('cancel'))));
    }));
};
ProjectNameForm.propTypes = {
    onCancel: T.func.isRequired,
    onContinue: T.func.isRequired
};
ProjectNameForm.defaultProps = {
    onCancel: noop,
    onContinue: noop
};
export default ProjectNameForm;
